module.exports = __webpack_public_path__ + "assets/img/1e5855394764f48696e0c62aa3863913.png";